// PrintPDF.js
import { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "antd";
import { exportNotifyGuarantor28New } from "./NotifyGuarantor28New";
import "./css/loadprint.css";
import { exportNotifyGuarantor3NNew } from "./NotifyGuarantor3NNew";

function PrintPDF({ dataTabelB, selectedContract, printingAll, setPrintingAll, roundDate }) {

  const [batchIndex, setBatchIndex] = useState(0);
  const [printing, setPrinting] = useState(false);
  const conponentPDF = useRef();

  // const [currentBatchNum, setCurrentBatchNum] = useState(0); // เอาไว้โชว์เลขหน้าปุ่ม
  const batchSize = 200; // ✅ แบ่งชุดละ 300
  const totalBatches = Math.ceil(dataTabelB.length / batchSize);
  const currentBatchNumber = batchIndex + 1;

  // eslint-disable-next-line no-unused-vars
  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: `ใบบอกกล่าวผู้ค้ำประกัน-${batchIndex + 1}`,
    onAfterPrint: () => {
      if ((batchIndex + 1) * batchSize < dataTabelB.length) {
        // พิมพ์ชุดถัดไป
        setBatchIndex(batchIndex + 1);
      } else {
        setPrinting(false);
        setPrintingAll(false); // ปลดล็อกปุ่มค้นหา
        setBatchIndex(0);
      }
    },
  });

  const handlePDF = async () => {
    // if (selectedContract?.key === "psfhp" || selectedContract?.key === "rpsl") {
    //   handleExport3()
    // } else {

    handleExport()

    // }
  };

  const triggerPrintWindow = (blobUrl) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.top = "-9999px";
    iframe.style.left = "-9999px";
    iframe.style.width = "1000px";
    iframe.style.height = "1000px";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    iframe.onload = () => {
      const win = iframe.contentWindow;
      win.focus();
      win.print();

      // ตั้งเวลาลบ iframe ทิ้ง (เผื่อไว้ 5 นาทีค่อยลบ เพื่อไม่ให้ error ตอนปริ้น)
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 300000);
    };

    iframe.src = blobUrl;
  };

  const handleExport = async () => {
    if (!dataTabelB?.length) return;

    setPrinting(true);
    setPrintingAll(true);

    const batchSize = 200;
    const totalBatches = Math.ceil(dataTabelB.length / batchSize);

    try {
      for (let i = 0; i < totalBatches; i++) {
        setBatchIndex(i + 1)
        // setCurrentBatchNum(i + 1);

        // 1. เตรียมข้อมูล
        const batchData = dataTabelB.slice(
          i * batchSize,
          (i + 1) * batchSize
        );

        let blobUrl;

        if (selectedContract?.key === "psfhp" || selectedContract?.key === "rpsl") {
          // 2. สร้าง PDF
          blobUrl = await exportNotifyGuarantor3NNew(
            batchData,
            selectedContract,
            i + 1
          );
        } else {
          // 2. สร้าง PDF
          blobUrl = await exportNotifyGuarantor28New(
            batchData,
            selectedContract,
            i + 1
          );

        }


        // 3. สั่งปริ้น
        triggerPrintWindow(blobUrl);

        // 4. 🔥 แก้ใหม่: ใช้การวนเช็ค (Polling) แทน Event Listener
        if (i < totalBatches - 1) {

          // รอ 1 วินาที ให้หน้าต่าง Print เด้งขึ้นมาให้เรียบร้อยก่อน
          await new Promise(r => setTimeout(r, 1000));

          // วนลูปเช็คทุก 1 วินาที จนกว่า User จะปิดหน้าต่าง Print (Focus กลับมาที่หน้าเว็บ)
          await new Promise((resolve) => {
            const checkInterval = setInterval(() => {
              // document.hasFocus() จะเป็น true ก็ต่อเมื่อหน้าต่าง Print ถูกปิดลงแล้ว
              if (document.hasFocus()) {
                clearInterval(checkInterval); // หยุดเช็ค
                resolve(); // ไปต่อ!
              }
            }, 1000);
          });

          // พักอีกนิดนึง (0.5วิ) เพื่อความชัวร์ว่า Browser เคลียร์ Dialog หมดแล้วจริงๆ
          await new Promise(r => setTimeout(r, 500));

          const msg = `พิมพ์ชุดที่ ${i + 1} เสร็จเรียบร้อย\nกด OK เพื่อพิมพ์ชุดที่ ${i + 2} ต่อ`;
          const userClickedOK = window.confirm(msg);

          // คืน RAM
          URL.revokeObjectURL(blobUrl);

          if (!userClickedOK) {
            break;
          }
        } else {
          // รอบสุดท้าย รอแป๊บเดียวแล้วจบเลย
          await new Promise(r => setTimeout(r, 2000));
          URL.revokeObjectURL(blobUrl);
        }
      }

    } catch (error) {
      console.error("Error:", error);
      alert("เกิดข้อผิดพลาด: " + error.message);
    } finally {
      setPrinting(false);
      setPrintingAll(false);
      // setCurrentBatchNum(0);
    }
  };

  useEffect(() => {
    // if (printing) {
    //   generatePDF();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchIndex, printing]);
  return (
    <>
      <Button type="primary" onClick={handlePDF} disabled={printing} danger>
        {printing
          ? `กำลังพิมพ์ ${currentBatchNumber}/${totalBatches}`
          : `พิมพ์ PDF (${dataTabelB.length} ใบ)`}
      </Button>
      {/* render หน้ารายงานเมื่่อกดพิมพ์ PDF */}
      {/* {printing &&
        (selectedContract?.key === "lsfhp" ? (
          <Alert message="บช 1 เอกสารไม่เสร็จ ตามกับทนายเด้อ" type="error" showIcon />
        ) : selectedContract?.key === "psfhp" || selectedContract?.key === "rpsl" ? (
          <div className="print-only" ref={conponentPDF}>
            {currentBatch.map((item, index) => (
              <NotifyGuarantor3N key={index} dataTabelB={item} selectedContract={selectedContract} indexA={index} indexB={currentBatchNumber} roundDate={roundDate}/>
            ))}
          </div>
        ) : (
          <div className="print-only" ref={conponentPDF}>
            {currentBatch.map((item, index) => (
              <NotifyGuarantor28 key={index} dataTabelB={item} selectedContract={selectedContract} indexA={index} indexB={currentBatchNumber} roundDate={roundDate}/>
            ))}
          </div>
        ))} */}
    </>
  );
}
export default PrintPDF;

